import styled from 'styled-components';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Form as FormBase } from '@unform/web';
import { transparentize } from 'polished';
import { Table as GlobalTable } from 'styles/global';
import { ButtonBase } from 'components/Button/styles';

interface ColumnContentProps {
  $columns: string;
}
interface ScrollProps {
  $height?: string;
}
export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  h4 {
    position: absolute;
    margin-left: 15px;
  }
`;
export const Scroll = styled(PerfectScrollbar)<ScrollProps>`
  height: ${props => (props.$height ? props.$height : 'auto')};
`;

export const Content = styled.div`
  header {
    display: flex;
    align-items: baseline;
  }
`;

export const Table = styled(GlobalTable)`
  margin: 10px 10px 0 10px;
  width: -webkit-fill-available;
  th {
    // Palavras-chaves
    &:nth-of-type(3) {
      text-align: center;
    }
    // Data de Exibição e Data de Criação
    &:nth-of-type(4),
    &:nth-of-type(6) {
      text-align: center;
      width: 170px;
    }
    // Flags: Visibilidade e Card
    &:nth-of-type(5) {
      text-align: center;
      width: 160px;
    }
    // Ações
    &:nth-of-type(7) {
      width: 100px;
      text-align: end;
    }
  }
  td {
    // Data de Exibição e Data de Criação
    &:nth-of-type(4),
    &:nth-of-type(6) {
      text-align: center;
    }
    // Palavras-chaves
    &:nth-of-type(3) {
      display: flex;
      gap: 5px;
      justify-content: center;
      button {
        white-space: nowrap;
        background: none;
        border: ${props => `1px solid ${props.theme.fontColor}`};
        border-radius: 20px;
        padding: 5px 10px;
        font: inherit;
        font-size: small;
        color: inherit;
        cursor: pointer;
        &:hover {
          opacity: 0.6;
        }
      }
    }
    // Ações
    &:nth-of-type(7) {
      display: flex;
      justify-content: flex-end;
    }
  }
`;

export const Form = styled(FormBase)`
  display: flex;
  height: 100%;
  flex-direction: column;
  /* justify-content: space-between; */
  padding: 0 15px;
  section {
    padding: 0 0 5px 0 !important;
    margin: 0px 0 15px 0;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};
  }
  // Button Area
  > div {
    &:last-of-type {
      display: flex;
      justify-content: space-between;
    }
  }
`;

export const ColumnContent = styled.div<ColumnContentProps>`
  display: grid;

  grid-template-columns: 1fr 1fr;
  grid-template-columns: ${props => props.$columns};
  grid-column-start: 1;
  grid-column-end: 2;
  margin-bottom: 10px;
  height: 100%;
  gap: 10px;

  section {
    display: flex;
    justify-content: space-between;

    padding: 0 0 5px 0 !important;
    margin-bottom: 15px;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};

    &:first-of-type {
      margin: 0px 0 15px 0;
    }

    ${ButtonBase} {
      margin-top: -10px;
    }
  }
`;

export const RecriaCardModal = styled.div`
  button {
    width: 200px;
    margin: 30px auto 0 auto;
  }
`;
